// <copyright file="licenses.service.ts" company="Signify Holding">
//     Copyright © 2015 - 2021, All Rights Reserved.
// </copyright>

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { LicenseDetailsDTO } from '../../dtos';

@Injectable()
export class LicensesService {
    private baseUrl = 'api/customer';

    constructor(private httpClient: HttpClient) { }

    public getLicenses(customerId: number, venueId: number): Observable<Array<LicenseDetailsDTO>> {
        return this.httpClient.get<Array<LicenseDetailsDTO>>
            (this.baseUrl + '/GetLicensesByCustomerAndVenue/' + customerId + '/' + venueId);
    }
}
